import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var Push = /*#__PURE__*/function () {
  function Push() {
    _classCallCheck(this, Push);
    this.default = true;
    this.groups = [];
    this.quantity = 4;
  }
  _createClass(Push, [{
    key: "particles_nb",
    get: function get() {
      return this.quantity;
    },
    set: function set(value) {
      this.quantity = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a;
      if (data === undefined) {
        return;
      }
      if (data.default !== undefined) {
        this.default = data.default;
      }
      if (data.groups !== undefined) {
        this.groups = data.groups.map(function (t) {
          return t;
        });
      }
      if (!this.groups.length) {
        this.default = true;
      }
      var quantity = (_a = data.quantity) !== null && _a !== void 0 ? _a : data.particles_nb;
      if (quantity !== undefined) {
        this.quantity = quantity;
      }
    }
  }]);
  return Push;
}();